import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { take } from "rxjs/operators";
import { InvGoodsKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Goods } from "src/app/backoffice/inv/models/goods.model";
interface SaleFormulaCoding {
  Code: number;
  Kind: InvGoodsKind;
}
@Component({
  selector: "ngx-sale-item-form",
  templateUrl: "./sale-item-form.component.html",
  styleUrls: ["./sale-item-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleItemFormComponent extends BaseFormComponent<Goods> {
  codingList: SaleFormulaCoding[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "SaleFormula/Goods";
    this.customColumnInfoApi = "SaleFormula/GetFormColumnInfo";
    this.label = this.translate("ClientApp.FrontOffice.Inv.SaleFormula.Goods");
    super.ngOnInit();
    this.codingList = await this.httpCommonService.get<SaleFormulaCoding[]>("SaleFormula/GoodsCoding").toPromise();
  }

  setdefault(): void {}

  addControl(): void {}

  onFieldsChanges(value: any) {
    if (this.codingList.length && value?.Category === "GoodsKind") {
      if (this.currentrow?.GoodsKindId !== value.Id) {
        const code = this.codingList.find((x) => x.Kind == value.Code)?.Code?.toString();
        if (code) {
          this.model.Code = code;
          this.setValue("Code", code);
        }
      } else if (this.currentrow) {
        this.model.Code = this.currentrow.Code;
        this.setValue("Code", this.currentrow.Code);
      }
    }
  }

  public async save() {
    try {
      if (this.isValid()) {
        this.beforupdate();
        this.sts.showToast("info", "", this.translate("ClientApp.FrontOffice.Inv.SaleFormula.SavingChanges"));
        this.isSaving = true;
        this.isSaved = false;
        if (this.isNewRow || this.id === undefined || this.id === 0 || Number.isNaN(this.id) || this.id === null) {
          await this.httpCommonService
            .create("SaleFormula/CreateGoods", this.getDataFromFormGroup())
            .pipe(take(1))
            .toPromise()
            .then(
              (row) => this.saveSuccessHelper(row),
              (error) => this.saveFailedHelper(error)
            );
        } else {
          await this.httpCommonService
            .update("SaleFormula/UpdateGoods", this.getDataFromFormGroup())
            .pipe(take(1))
            .toPromise()
            .then(
              (response) => this.saveSuccessHelper(),
              (error) => this.saveFailedHelper(error)
            );
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }
}
